export default "__VITE_ASSET__jiSOAUdJ__"